<template>
    <div id="home">

        <div class="logout">
            <router-link tag="el-button" to="/" class="navigation-item">
                <i class="el-icon-user"></i>
                <span>Logout</span>
            </router-link>
        </div>

        <div class="container">
            <el-row :gutter="22">
                <el-col :xs="24" :sm="12">
                    <div class="button" @click="link('create')">
                        <el-card shadow="hover">
                            <i class="el-icon-edit-outline"></i>
                            <span>Erfassen</span>
                        </el-card>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12">
                    <div class="button" @click="link('overview')">
                        <el-card shadow="hover">
                            <i class="el-icon-discover"></i>
                            <span>Übersicht</span>
                        </el-card>
                    </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'home',
        methods: {
            link(to) {
                this.$router.push(to)
            }
        }
    }
</script>

<style lang="scss" scoped>
    #home {
        @include fullscreen;
        @include center_content;

        .logout {
            position: absolute;
            top: 0;
            right: 22px;
            height: 60px;
            padding: $padding * 11;
        }
    }

    .button {
        cursor: pointer;

        > * {
            border-top-color: $color-secondary;
            display: flex;
            justify-content: center;
            align-items: center;
            white-space: nowrap;
            padding: $padding * 11;
            margin: $padding/2 * 11 0;


            font-size: 2rem;
        }
    }
</style>
